/**
 * 작성자 : 한영광
 * 날짜 : 2023.07.10
 * 경로 : 센서 관리 - 소음 측정기
 */

/**
 * 수정자 : 박승호
 * 수정일 : 2026.08.04
 * 수정내용 : 센서 관리 - 소음 측정 이력 탭 화면 추가
 */

import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { ITabObject } from 'customTypes';
import { IUser, pageInfoState, userState } from '../../atoms';
import Tab from '../../components/Tab';
import GeneralSound from './sensor2/GeneralSound';
import HistorySound from './sensor2/HistorySound';

const Ssensor2 = () => {
  const userInfo = useRecoilValue<IUser>(userState);
  const { userMenuList } = userInfo;
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const [newTabList, setNewTabList] = useState<ITabObject[]>();

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = newTabList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <GeneralSound />;
        case '002':
          return <HistorySound />;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      {renderPage()}
    </div>
  );
};

export default Ssensor2;
